import { ReactNode, useCallback, useState } from "react";
import { NavLink } from "react-router";
import t from "@/lang/lang";
import {
  MicrobialBaseDataTable,
  MicrobialBaseDataTableFilters,
  useDefaultHtzMicrobialBaseDataListRequest,
} from "@/services/backend/htz/inspection/components/microbial-base-data-table";
import { CreateMicrobialBaseDataDialog } from "@/services/backend/htz/inspection/components/create-microbial-base-data-dialog";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export function MicrobialAssessmentsRoute() {
  const [request, setRequest] = useState(
    useDefaultHtzMicrobialBaseDataListRequest(),
  );

  const renderRowLink = useCallback(
    (baseDataId: string, children: ReactNode) => (
      <NavLink to={baseDataId}>{children}</NavLink>
    ),
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Mikrobiologische Beurteilung")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Sie die Handlungsempfehlungen verwalten, die mikrobiologische Beurteilungen je nach Ergebnis erhalten. Ein neuer Anlagenbericht übernimmt die als aktiv markierten Basisdaten.",
          )}
        </CardDescription>
        <CardAction>
          <CreateMicrobialBaseDataDialog />
        </CardAction>
      </CardHeader>
      <CardContent className="grid gap-2">
        <MicrobialBaseDataTableFilters
          request={request}
          onRequestChange={setRequest}
        />
        <MicrobialBaseDataTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={renderRowLink}
          hideBorder
        />
      </CardContent>
    </Card>
  );
}
